import { useCallback, useEffect, useState } from 'react';
import getVendorsFood from '@utils/vendorsFood/vendorsFood';
import { keysToCamel } from '@/src/models/foodMapper';
import useAppContext from '@hooks/useAppContext';

function useGetFood(pagination) {
  const { location, user } = useAppContext();
  const [loading, setLoading] = useState(true);
  const [vendorError, setVendorError] = useState(undefined);
  const [vendors, setVendors] = useState([]);
  const [totalVendors, setTotalVendors] = useState(0);
  const [page, setPage] = useState(pagination?.page || 1);
  const [size, setSize] = useState(pagination?.size || 10);
  const [midasRequestId, setMidasRequestId] = useState('');
  const [vendorsPerPage, setVendorsPerPage] = useState([]);

  const getFoodVendors = useCallback(async () => {
    try {
      setLoading(true);

      const {
        searchedLocation: { latitude: lat, longitude: lng },
        country: { id: countryId },
      } = location;

      const { data, error } = await getVendorsFood(
        user?.id || null,
        lat,
        lng,
        countryId,
        page,
      );

      if (error) {
        if (error?.response?.status) {
          setVendorError(error.response.status);
        }
        if (error?.code === 'ECONNABORTED') {
          // error by timeout
          setVendorError('ECONNABORTED');
        }
        setVendorError(error);
      } else if (data && data.vendors?.length > 0) {
        const vendorIds = keysToCamel(data.vendors).map((vendor) => vendor.id);
        setVendorsPerPage([vendorIds]);
        setVendors(keysToCamel([...vendors, ...data.vendors]));
        setTotalVendors(data.pagination?.total);
        setSize(data.pagination?.size);
        setVendorError(undefined);
        setMidasRequestId(data.metadata?.midas_request_id);
      }
    } finally {
      setLoading(false);
    }
  }, [vendors, page, location, user]);

  useEffect(() => {
    if (loading) {
      getFoodVendors();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, page]);
  return {
    loading,
    vendorError,
    vendors,
    totalVendors,
    setVendorError,
    setVendors,
    setTotalVendors,
    getFoodVendors,
    setLoading,
    page,
    setPage,
    size,
    midasRequestId,
    vendorsPerPage,
  };
}

export default useGetFood;
